import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isLoggedIn, loginEntra } from "./webapi/AuthService";
import { useMsal } from "@azure/msal-react";
import moment from "moment";

const withAuthorization = Component => {
  const WithAuthorization = props => {
    const navigate = useNavigate();
    const location = useLocation();
    const isTokenExpired = token => {
      if (token && token.expiresOn) {
        return moment() > moment(token.expiresOn).subtract(10, "seconds");
      }

      return true;
    };
    const { instance, accounts, inProgress } = useMsal();
    const loggedIn = isLoggedIn();
    const [entraAvailable, setEntravailable] = useState(false);

    useEffect(() => {
      const checkEntra = async () => {
        const tenantId = "8aa2700d-6dd8-4a55-af2c-532e1553866a";
        const zebraAccounts = accounts.filter(
          account => account.tenantId === tenantId
        );
        if (zebraAccounts.length === 0) window.location.replace("/signin");

        const token = await instance.acquireTokenSilent({
          scopes: ["api://fc46b6fa-e947-43a2-8d21-e93c7e83c51b/zebra.login"],
          account: zebraAccounts[0]
        });

        if (isTokenExpired(token)) window.location.replace("/signin");

        loginEntra(token.account.username, token.accessToken).then(data => {
          if (data.ID) {
            navigate(localStorage.getItem("redirectUrl"));
          } else {
            window.location.replace("/signin");
          }
        });
      };

      if (!loggedIn) {
        localStorage.setItem("redirectUrl", location.pathname);
        if (entraAvailable) {
          checkEntra();
        } else {
          window.location.replace("/signin");
        }
      }
    }, [location.pathname]);

    return loggedIn ? <Component {...props} /> : null;
  };

  return WithAuthorization;
};

export default withAuthorization;
